module.exports = __webpack_public_path__ + "img/a6.5e0517fd.jpg";